import React from 'react';

import { DEFAULT_ELEVATION } from './constants';
import { StyledCard } from './styled';
import { ICardProps } from './types';
import { useUnit } from '@unfold/theme';

export const Card = React.forwardRef<HTMLDivElement, ICardProps>(
  ({ children, elevation = DEFAULT_ELEVATION, ...props }, ref) => {
    return (
      <StyledCard ref={ref} elevation={elevation} {...props}>
        {children}
      </StyledCard>
    );
  }
);

Card.displayName = 'UnfoldCard';
